import { HStack, VStack } from "@gluestack-ui/themed";
import { SimulatedConditionsSectionProps } from "./types";
import { Text } from "@repo/core/components/core/Text";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ConditionInfo } from "../../infos/ConditionInfo";

export const SimulatedConditionsSection = ({
  value,
  interestPercentage,
  interestValue,
  iof,
  cet,
  totalValue,
  installmentsQuantity,
  installmentValue
}: SimulatedConditionsSectionProps) => {
  return (
    <VStack gap={16} py="$4">
      <HStack alignItems="center" gap={8}>
        <Text fontWeight={600}>Condições</Text>
      </HStack>

      <VStack
        borderRadius={8}
        borderWidth="$1"
        borderColor="$borderLight200"
        overflow="hidden"
      >
        <ConditionInfo name="Valor" value={numberToBrl(value)} />
        <ConditionInfo
          name={`Juros (${interestPercentage}% ao mês)`}
          value={numberToBrl(interestValue)}
          isGray
        />
        <ConditionInfo name="IOF" value={`+ ${numberToBrl(iof)}`} />
        <ConditionInfo
          name="CET (a.a.)"
          value={`${Number(cet).toFixed(2)}%`}
          isGray
        />
        <ConditionInfo
          name="Valor Total"
          value={numberToBrl(totalValue)}
          isBold
        />
        <ConditionInfo
          name="Parcelas"
          value={`${installmentsQuantity}x de ${numberToBrl(installmentValue)}`}
          isBold
          isGray
        />
      </VStack>
    </VStack>
  );
};
